import { FC } from 'react'
import { useNavigate } from 'react-router-dom'
import TermsOfServiceDialog from '../../../components/TermsOfServiceDialog'
import PrivacyPolicyDialog from '../../../components/PrivacyPolicyDialog'

export const Footer: FC = () => {
  const currentYear = new Date().getFullYear()
  const navigate = useNavigate()

  return (
    <footer className="relative px-6 md:px-12 lg:px-24 py-16 border-t border-neutral200 dark:border-neutral800 bg-white dark:bg-neutral900">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 mb-12">
          {/* Brand - spans more space */}
          <div className="md:col-span-5">
            <div 
              className="flex items-center mb-4 cursor-pointer group" 
              onClick={() => navigate('/')}
            >
              <span className="text-xl font-bold text-neutral900 dark:text-neutral100">
                Inventory
                <span className="text-sumoPrimary group-hover:text-sumoAmber transition-colors">
                  Sumo
                </span>
              </span>
            </div>
            <p className="text-neutral500 dark:text-neutral400 max-w-sm leading-relaxed">
              Professional inventory management for resellers and small businesses. Simplify your workflow, grow your business.
            </p>
          </div>

          {/* Product links */}
          <div className="md:col-span-3">
            <h4 className="text-sm font-semibold text-neutral900 dark:text-neutral100 uppercase tracking-wider mb-4">
              Product
            </h4>
            <ul className="space-y-3">
              <li>
                <a 
                  href="#features" 
                  className="text-neutral500 dark:text-neutral400 hover:text-sumoPrimary dark:hover:text-sumoPrimary transition-colors text-sm"
                >
                  Features
                </a>
              </li>
              <li>
                <a 
                  href="#pricing" 
                  className="text-neutral500 dark:text-neutral400 hover:text-sumoPrimary dark:hover:text-sumoPrimary transition-colors text-sm"
                >
                  Pricing
                </a>
              </li>
            </ul>
          </div>

          {/* Account links */}
          <div className="md:col-span-2">
            <h4 className="text-sm font-semibold text-neutral900 dark:text-neutral100 uppercase tracking-wider mb-4">
              Account
            </h4>
            <ul className="space-y-3">
              <li>
                <a 
                  href="/login" 
                  className="text-neutral500 dark:text-neutral400 hover:text-sumoPrimary dark:hover:text-sumoPrimary transition-colors text-sm"
                >
                  Sign In
                </a>
              </li>
              <li>
                <a 
                  href="/create-account" 
                  className="text-neutral500 dark:text-neutral400 hover:text-sumoPrimary dark:hover:text-sumoPrimary transition-colors text-sm"
                >
                  Get Started
                </a>
              </li>
            </ul>
          </div>

          {/* Legal links */}
          <div className="md:col-span-2">
            <h4 className="text-sm font-semibold text-neutral900 dark:text-neutral100 uppercase tracking-wider mb-4">
              Legal
            </h4>
            <ul className="space-y-3">
              <li>
                <PrivacyPolicyDialog
                  triggerClassName="text-neutral500 dark:text-neutral400 hover:text-sumoPrimary dark:hover:text-sumoPrimary transition-colors text-sm cursor-pointer"
                  linkText="Privacy"
                />
              </li>
              <li>
                <TermsOfServiceDialog
                  triggerClassName="text-neutral500 dark:text-neutral400 hover:text-sumoPrimary dark:hover:text-sumoPrimary transition-colors text-sm cursor-pointer"
                  linkText="Terms"
                />
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar - Clean ending */}
        <div className="pt-8 border-t border-neutral200 dark:border-neutral800">
          <p className="text-neutral400 dark:text-neutral500 text-sm text-center">
            © {currentYear} InventorySumo. Built with care for sellers everywhere.
          </p>
        </div>
      </div>
    </footer>
  )
}
